import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from "react";
import "./styles.css";
import { toastManager } from "../../services/toastManager";

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

let nextId = 1;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const timersRef = useRef({});

  const removeToast = useCallback((id) => {
    clearTimeout(timersRef.current[id]);
    delete timersRef.current[id];
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback((type, message) => {
    const id = nextId++;
    setToasts((prev) => [...prev, { id, type, message }]);
    timersRef.current[id] = setTimeout(() => removeToast(id), 5000);
  }, [removeToast]);

  useEffect(() => {
    const unsubscribe = toastManager.subscribe(({ type, message }) => addToast(type, message));
    return unsubscribe;
  }, [addToast]);

  // Clean up all timers on unmount
  useEffect(() => {
    const timers = timersRef.current;
    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, []);

  const toastTypeClass = {
    success: "toast-success",
    error: "toast-error",
    warning: "toast-warning",
    info: "",
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="toast-container">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${toastTypeClass[t.type] || ""}`}>
            {t.message}
            <button type="button" className="close" onClick={() => removeToast(t.id)}>
              &times;
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
